<template>
  <div>
    <a-button icon="bg-colors" @click='toggle = !toggle' class="icon-button">更换图标</a-button>
    <ul class="list-a" v-show='toggle'>
      <li v-for="(item, index) in icons" :key="index">
        <img :src="$_c + item" @click="onSelect" :path="item" style="width:40px;">
      </li>
    </ul>
  </div>
</template>

<script>
const ICONS = [
  'app/workflow/img/design/v1/1.png', 'app/workflow/img/design/v1/2.png',
  'app/workflow/img/design/v1/3.png', 'app/workflow/img/design/v1/4.png',
  'app/workflow/img/design/v1/5.png', 'app/workflow/img/design/v1/6.png',
  'app/workflow/img/design/v1/7.png', 'app/workflow/img/design/v1/8.png',
  'app/workflow/img/design/v1/9.png', 'app/workflow/img/design/v1/10.png',
  'app/workflow/img/design/v1/11.png', 'app/workflow/img/design/v1/12.png',
  'app/workflow/img/design/v1/13.png', 'app/workflow/img/design/v1/14.png',
  'app/workflow/img/design/v1/15.png', 'app/workflow/img/design/v1/16.png',
  'app/workflow/img/design/v1/17.png', 'app/workflow/img/design/v1/18.png',
  'app/workflow/img/design/v1/19.png', 'app/workflow/img/design/v1/20.png',
  'app/workflow/img/design/v1/21.png', 'app/workflow/img/design/v1/22.png',
  'app/workflow/img/design/v1/23.png', 'app/workflow/img/design/v1/24.png',
  'app/workflow/img/design/v1/25.png'
]

export default {
  name: 'WFIconSelector',
  data () {
    return {
      toggle: false,
      icons: ICONS
    }
  },
  methods: {
    onSelect (event) {
      let path = event.target.getAttribute('path')
      this.$emit('change', path)
    }
  }
}
</script>

<style scoped>
.icon-button {
  color: #0080ff;
}

.list-a {
  list-style: none;
  display: block;
  font-size: 0;
  border: 1px solid #e6e6e6;
  padding: 12px;
  margin-top: 12px;
}

.list-a li {
  width: 10%;
  text-align: center;
  display: inline-block;
  padding: 6px 0;
}

.list-a li:hover {
  background: #f9f9f9;
}
</style>
